module.exports = __webpack_public_path__ + "img/挣钱攻略.27fb00be.png";